/* Biohakkerikauppa brand behaviours: staggered reveal of cards on scroll. */
(function () {
  const root = document.documentElement;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('bhk-js');
  // Elements present at first paint are revealed on the next frame so the page never looks empty
  // if the observer is slow; later ones animate in as they scroll into view.

  const SELECTOR = [
    '.blog-post-item',
    '.featured-blog-posts-card',
    '.product-grid > *',
    '#MainContent .text-block:not(.product-card *):not(.blog-post-card *):not(.featured-blog-posts-card *)',
    '#MainContent .image-block:not(.product-card *)',
    '#MainContent .button:not(.product-card *):not(.bhk-sticky *):not(.slideshow-control):not(slideshow-controls *):not(dialog *):not(.close-button):not(.dialog-close-button)',
    '#MainContent .email-signup-block',
  ].join(', ');
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('bhk-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  const stagger = (el) => {
    const parent = el.parentElement;
    if (!parent) return;
    const siblings = Array.from(parent.children).filter((c) => c.matches(SELECTOR));
    const index = Math.max(0, siblings.indexOf(el));
    // Stagger within each row of up to four cards, so long grids do not wait on early items.
    // Text, buttons and images inside a group stagger by their position in the group.
    const step = el.matches('.text-block, .button, .image-block, .email-signup-block') ? 90 : 70;
    el.style.setProperty('--bhk-reveal-delay', `${(index % 6) * step}ms`);
  };

  const attach = () => {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      // Re-observe anything not yet revealed: Horizon may clone or morph a block after the
      // first pass (product details, section re-renders), which drops the observer.
      if (el.classList.contains('bhk-revealed')) return;
      if (!el.dataset.bhkReveal) {
        el.dataset.bhkReveal = '1';
        el.classList.add('bhk-pre');
        stagger(el);
      }
      observer.observe(el);
    });
  };

  attach();
  // Paginated lists and section re-renders (theme editor, filters) add cards later.
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
})();

/* Footer "Evästeasetukset": reopen Shopify's native cookie consent preferences. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#evasteasetukset"]');
  if (!link) return;
  event.preventDefault();
  const banner = window.privacyBanner;
  if (banner && typeof banner.showPreferences === 'function') banner.showPreferences();
  else if (banner && typeof banner.loadBanner === 'function') banner.loadBanner();
  else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showBanner === 'function') window.Shopify.customerPrivacy.showBanner();
});
